import * as React from 'react';
import * as ReactDOM from 'react-dom';

// Save a reference to the root element for reuse
const rootEl = document.getElementById('root');

// Create a reusable render method that we can call more than once
const render: VoidFunction = () => {
    // Dynamically import our main App component, and render it
    // eslint-disable-next-line global-require
    const {default: MainApp} = require('./App.tsx');
    ReactDOM.render(<MainApp />, rootEl);
};

if (module.hot) {
    module.hot.accept('./App.tsx', () => {
        render();
    });
}

if (process.env.NODE_ENV === 'production') {
    const runtime = require('offline-plugin/runtime');
    runtime.install({
        onUpdating: () => {
            console.log('SW Event:', 'onUpdating');
        },
        onUpdateReady: () => {
            console.log('SW Event:', 'onUpdateReady');
            // Tells to new SW to take control immediately
            runtime.applyUpdate();
        },
        onUpdated: () => {
            console.log('SW Event:', 'onUpdated');
            // Reload the webpage to load into the new version
            window.location.reload();
        },

        onUpdateFailed: () => {
            console.log('SW Event:', 'onUpdateFailed');
        },
    });
}

render();